module.exports = __webpack_public_path__ + "img/a2.4db1a36c.png";